/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener("DOMContentLoaded", function(){
  if(document.querySelector('.Product__Wrapper') != null) {
  	var productWrapper = document.querySelector('.Product__Wrapper');
  	//var ProdutWrapperStyle = document.querySelector('.Product__Wrapper').getAttribute('style');
  	var productWrapHeight = productWrapper.offsetHeight;
    if( window.innerWidth > 1007) {
      if(document.querySelector('.Product__Info').offsetHeight > productWrapHeight) {
        productWrapper.setAttribute('style', 'height: ' + document.querySelector('.Product__Info').offsetHeight + 'px;');
      }
    }
  	
  	document.querySelector('.ProductMeta__Description.Rte').addEventListener( "click" , function(e) {
    	var windowWidth = window.innerWidth;
      
      if( windowWidth > 1007) {
           if (e.target.classList.contains('ui-accordion-header') || e.target.classList.contains('ui-accordion-header-icon')) {
             	document.querySelector('.Product__Info').style.height = 'auto';
              setTimeout(function() {
                var productInfoHeight = document.querySelector('.Product__Info').offsetHeight;

                if(productInfoHeight < productWrapHeight) {
                  productWrapper.setAttribute('style', 'height: ' + productWrapHeight + 'px;');
                } else {
                  productWrapper.setAttribute('style', 'height: ' + productInfoHeight + 'px;');
                }

              }, 300);
           }
      	}
    });
  }
});


document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  //alert(variant.id);
  $(".ctm-slider").hide();
  $(".ctm-description").hide();
  $(".main-container-"+variant.id).show();
  $("#ctm-desc-"+variant.id).show();
  setInterval(function(){
  $(window).resize();
  },200);
});

//added by Yogesh 31-01-2020
if (window.jQuery && document.querySelector('healcode-widget') != null) {
 doneJQ();
}



function doneJQ() {
  if(window.hcInitialized) {
   $(document).ready(function() { 
    $("healcode-widget a#hc-find-appt").click(function(event){             
        event.preventDefault(); 
        check();
   });
  $("healcode-widget a").click(function(event){             
        event.preventDefault(); 
   }); 
    
     
}); 
  } else {
    setTimeout(function () { 
        doneJQ();
    }, 1000);
  }
};

function check() {
    if( !$.trim( $('#appointment_results').html() ).length ) {
        return setTimeout(check, 1000);
    } else {
      doneJQ();
    }
}




